<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="proId"
      :col="6"
      :itemNames="['search_proName','create_button']"
      :columns="getColumns()"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proName">
        <a-input v-model="queryParams.proName" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
      </a-form-item>
      <template slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.phone }}</div>
      </template>
    </search-page-view>
  </a-card>
</template>

<script>
export default {
  name: 'DirectOrder',
  data() {
    return {
      queryParams: {
        orderType: 31
      },
      loadPromise: params => this.getListPromise(params),
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ZwyConnection', title: '同步产品' },
      { name: 'DirectOrder', title: '订单直连' },
      { name: 'AssociatedAccount', title: '关联账号' }
    ])
  },
  methods: {
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getOrderService().post('direct/getDirectOrderPage', params)
    },
    getColumns() {
      return [
        {
          title: '自我游订单号',
          dataIndex: 'supplerOrderNo'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '26%'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '订单来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        },
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        }
      ]
    }
  }
}
</script>

<style scoped></style>
